module.exports = __webpack_public_path__ + "static/media/nivt skill award.63597adb.jpg";